import { render, staticRenderFns } from "./InterestedSchoolProfile.vue?vue&type=template&id=0c5b3658&"
import script from "./InterestedSchoolProfile.vue?vue&type=script&lang=js&"
export * from "./InterestedSchoolProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports